'use strict';

var _ = require('lodash');
var Marionette = require('backbone.marionette');
var tpl = require('actions/oneoneNat/rule.html');
var RenderChanges = require('lib/behaviors/RenderChanges');
var twig = require('twig').twig;
var tplHelpers = require('lib/tplHelpers');

module.exports = Marionette.View.extend({
  behaviors: [{
    behaviorClass: RenderChanges,
  }],

  template: twig({data: tpl}),

  ui: {
    destIp: '[name="dest-ip"]',
    srcIp: '[name="secondary-ips"]',
    enabled: '[name="enabled"]',
    messages: '.help-block',
    remove: '.btn-remove',
  },

  events: {
    'change @ui.destIp': 'updateDestIp',
    'change @ui.srcIp': 'updateSrcIp',
    'change @ui.enabled': 'updateEnabled',
    'click @ui.remove': 'removeNat',
  },

  modelEvents: {
    'invalid': 'onError',
    'change:remove': 'render',
    'change:enabled': 'onEnabledChange',
  },

  onBeforeRender: function() {
    this.isItemOff = !this.model.get('enabled');
  },

  /**
   * @returns {Object}
   */
  templateContext: function() {
    var context = {
      ips: this.options.ips,
    };

    return _.extend(context, tplHelpers.apply(this));
  },

  updateDestIp: function(ev) {
    var value = ev.currentTarget.value;

    this.clearFieldError('destIp');
    this.model.set({'dest_ip': value}, {commit: true});
  },

  updateSrcIp: function(ev) {
    var value = ev.currentTarget.value;

    this.clearFieldError('srcIp');
    this.model.set({'src_dip': value}, {commit: true});
  },

  clearFieldError: function(key) {
    this.ui[key].bs3ui('clearGroupedFieldError', key, this.ui.messages);
  },

  updateEnabled: function(ev) {
    this.model.set({enabled: ev.currentTarget.checked});
  },

  /**
   * Decorates the view to indicate error.
   *
   * @param {Object} model
   * @param {Object} error
   * @param {Object} options
   */
  onError: function(model, error, options) {
    var self = this;
    Object.keys(error).forEach(function(key) {
      var value = error[key];
      self.ui[key].bs3ui('showGroupedFieldError', value, key, self.ui.messages);
    });
  },

  removeNat: function() {
    if (this.model.isNew()) {
      this.model.collection.remove(this.model);
    } else {
      var shouldRemove = !this.model.get('remove');

      if (shouldRemove) {
        this.model.applySnapshot();
      }

      this.model.set({remove: shouldRemove});
    }
  },

  onEnabledChange: function(model, value) {
    this.isItemOff = !value;
    this.triggerMethod('onoff:status:change', this);
  },
});
